import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface IProps {
	changeNameOfModifierGroup: (value: string) => void;
}

export const NameModifierGroupInput: React.FC<IProps> = React.memo(({ changeNameOfModifierGroup }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterModifierGroupName') }], [t]);

	return (
		<FormInput
			testId="NameModifierGroupInput"
			name="nameOfModifierGroup"
			label="nameOfModifierGroupLabel"
			onChange={changeNameOfModifierGroup}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
});
